<template>
  <div>
    <div class="text-right pb-3" v-if="allowMarking">
      <button :class="allIsDelivered ? 'btn-success' : 'btn-outline-success'"
              @click="allToDelivered" class="btn ml-2" type="button">
        Доставлено
      </button>
      <button :class="allIsPaid ? 'btn-success' : 'btn-outline-success'" @click="allToPaid"
              class="btn ml-2" type="button">Оплачено
      </button>
      <button :class="allIsPassed ? 'btn-success' : 'btn-outline-success'" @click="allToPassed"
              class="btn ml-2" type="button">Сдано
      </button>
    </div>
    <div class="text-right">
      <button @click.prevent="print" class="btn btn-warning ml-2" v-if="allowPrinting">Печать
      </button>
      <button @click="$router.go(-1)" class="btn btn-secondary ml-2" type="button">Назад</button>
    </div>
    <div class="mt-3" id="printMe">
      <!--      <table class="table table-sm table-borderless">-->
      <!--        <tbody>-->
      <!--        <tr>-->
      <!--          <td>-->
      <!--            Доставка: {{$route.query.time}}-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            <vue-barcode :value="courierBarCode" :width="2" height="20" :margin="0" display-value="false">-->
      <!--              Ошибка штрихкода-->
      <!--            </vue-barcode>-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            Курьер: {{courier.Mname}} {{courier.Lname}} {{courier.Fname}} ({{courier.Login}})-->
      <!--          </td>-->
      <!--          <td>-->
      <!--            {{currentDate}}-->
      <!--          </td>-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->

      <table class="table table-bordered table-hover table-sm w-100 table-cell-align-middle">
        <thead>
        <tr class="">
          <th class="d-print-none">
            <input type="checkbox" v-model="checkAll">
          </th>
          <th>Объезд</th>
          <th>Пункт</th>
          <th class="text-right" v-for="paymentType in allowPaymentTypes" width="60">
            {{ paymentType.Name }}
          </th>
          <th width="10"></th>
          <th class="d-print-none"></th>
          <th class="d-print-none">Дата оплаты</th>
          <th class="d-print-none">Дата получения</th>
          <th class="d-print-none" width="160">Дата доставки</th>
        </tr>
        </thead>
        <tbody>

        <template v-for="(receptionOrders) in orderListGroupByPoint">
          <template v-for="(order, index) in receptionOrders">
            <template v-if="index === 0">
              <tr class="font-weight-bold">
                <td class="d-print-none" width="1">
                  <input :checked="fullFilledPoint(order.Point.Id)"
                         @change="checkByPointId($event, order.Point.Id)" type="checkbox">
                </td>
                <td>{{ order.Tour.Name }}</td>
                <td :colspan="allowPaymentTypes.length + 1" width="70">
                  {{ order.Point.Reception }}
                  <span class="badge badge-warning font-weight-normal" style="font-size: 100%;"
                        v-if="pointDebt[order.Point.Id]">Долг: {{ pointDebt[order.Point.Id] }}</span>
                </td>
                <!--                                <td>Долг: -</td>-->
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
                <td class="d-print-none"></td>
                <td class="d-none d-print-table-cell" width="10">
                  <!--                  <vue-barcode :value="pointBarCode(order.Point)" :width="2" height="20" :margin="0" display-value="false">-->
                  <!--                    Ошибка штрихкода-->
                  <!--                  </vue-barcode>-->
                </td>
              </tr>
            </template>
            <tr>
              <td class="d-print-none" width="1">
                <input :value="order.Order.Id" type="checkbox" v-model="checkedOrders">
              </td>
              <td class="text-nowrap" style="width: 100px;">
                <router-link
                  target="_blank"
                  :to="{ name: 'order-info', params: {orderId: order.Order.Id}}">
                  {{ order.Order.RecastNumber > 0 ? 'Переделка заказа ' : '' }}
                  {{ order.Order.SferaNumber }}
                  {{ order.Order.LocalNumber && (`/ ${order.Order.LocalNumber}`) }}
                </router-link>
              </td>
              <td class="overflow-hidden text-nowrap"
                  style="max-width: 0; text-overflow: ellipsis;">
                {{ order.Order.Name }}
              </td>
              <td class="text-right text-nowrap" v-for="paymentType in allowPaymentTypes">
                {{ order.Order.PaymentTypeId === paymentType.Id ? (order.Order.Summary ? order.Order.Summary : '') : '' }}
              </td>
              <td class="d-print-none" width="30">
                <button @click.prevent="deleteDelivery([order.Delivery.Id])"
                        class="btn btn-outline-secondary btn-sm" type="button">
                  <font-awesome-icon :icon="['far', 'trash-alt']"/>
                </button>
              </td>
              <td class="d-print-none" width="50">
                <div class="dropdown">
                  <button aria-expanded="false"
                          aria-haspopup="true"
                          class="btn btn-outline-info dropdown-toggle btn-sm btn-block"
                          data-toggle="dropdown" id="dropdownMenuButton" type="button">
                    {{ getStatusNameById(order.Order.OrderStatusId) }}
                  </button>
                  <div class="dropdown-menu">
                    <h6 class="dropdown-header">Изменить статус</h6>
                    <a @click.prevent="setStatus([order.Order.Id], status.Code)"
                       class="dropdown-item" href="#"
                       v-for="status in allowedStatuses">{{ status.Name }}</a>
                    <h6 class="dropdown-header">Операции</h6>
                    <a @click.prevent="partPaid(order.Order.Id)" class="dropdown-item" href="#">Оплачен
                      частично</a>
                  </div>
                </div>
              </td>
              <td class="d-print-none" style="" width="170">
                <div class="d-flex flex-row">
                  <date-picker :editable="false"
                               :format="momentFormat"
                               @input="setPaidDate([order.Order.Id], $event)"
                               clearButton="false"
                               input-class="form-control form-control-sm"
                               lang="ru"
                               :first-day-of-week="1"
                               placeholder=""
                               style="width: auto;"
                               v-model="order.Order.PaidDate"
                               valueType="format">
                  </date-picker>
                  <button @click.prevent="setDeliveryPaidDate([order.Order.Id])"
                          class="btn btn-sm btn-outline-info ml-2"
                          content="Назначить дату оплаты из доставки"
                          type="button"
                          v-tippy>
                    <font-awesome-icon :icon="['far', 'calendar-plus']"/>
                  </button>
                </div>
              </td>
              <td class="d-print-none" style="" width="170">
                <div class="d-flex flex-row">
                  <date-picker :editable="false"
                               :format="momentFormat"
                               @input="setPassedDate([order.Order.Id], $event)"
                               clearButton="false"
                               input-class="form-control form-control-sm"
                               lang="ru"
                               :first-day-of-week="1"
                               placeholder=""
                               style="width: auto;"
                               v-model="order.Order.PassedDate"
                               valueType="format">
                  </date-picker>
                  <button @click.prevent="setCurrentPassedDate([order.Order.Id])"
                          class="btn btn-sm btn-outline-info ml-2"
                          content="Назначить текущую дату получения"
                          type="button"
                          v-tippy>
                    <font-awesome-icon :icon="['far', 'calendar-check']"/>
                  </button>
                </div>
              </td>
              <td>
                {{ order.Delivery.DeliveryDate }}
              </td>
              <td class="d-none d-print-table-cell" width="100">
                <vue-barcode :margin="0" :value="order.Order.SferaNumber" display-value="false"
                             height="20" width="2">
                  Ошибка штрихкода
                </vue-barcode>
              </td>
            </tr>
          </template>
        </template>
        </tbody>
        <tfoot class="font-weight-bold text-right">
        <tr>
          <td class="d-print-none" colspan="3">Итого долг</td>
          <td class="d-none d-print-table-cell" colspan="2">Итого долг</td>
          <td v-for="PaymentType in allowPaymentTypes">
            {{ totalAmount[PaymentType.Id] || 0 }}
          </td>
          <td class="d-print-none" colspan="2"></td>
          <td class="d-none d-print-table-cell"></td>
          <td class="d-print-none">{{ totalWithPaidDate }}</td>
          <td class="d-print-none">{{ totalWithPassedDate }}</td>
          <td class="d-print-none"></td>
        </tr>
        </tfoot>
      </table>


    </div>
    <div class="alert-info p-3 mb-3">
      <legend>Выбрано заказов: {{ checkedOrders.length }}</legend>
      <div class="d-flex flex-row">
        <div>
          <div>
            <label class="">Выберите статус</label>
          </div>
          <div class="dropdown">
            <button aria-expanded="false"
                    aria-haspopup="true"
                    class="btn btn-outline-info dropdown-toggle btn-sm btn-block"
                    data-toggle="dropdown" id="dropdownMenuButton" type="button">
              Выберите
            </button>
            <div class="dropdown-menu">
              <h6 class="dropdown-header">Изменить статус</h6>
              <a @click.prevent="setStatus(checkedOrders, status.Code)" class="dropdown-item"
                 href="#" v-for="status in allowedStatuses">{{ status.Name }}</a>
              <!--                <h6 class="dropdown-header">Операции</h6>-->
              <!--                <a class="dropdown-item" href="#">Оплачен частично</a>-->
            </div>
          </div>
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить дату оплаты</label>
          </div>
          <div>
            <date-picker :editable="false"
                         :format="momentFormat"
                         @input="setPaidDate(checkedOrders, $event)"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         v-model="allPaidDate"
                         valueType="format">
            </date-picker>
          </div>
        </div>
        <div class="ml-md-3">
          <div>
            <label class="">Применить дату получения</label>
          </div>
          <div>
            <date-picker :editable="false"
                         :format="momentFormat"
                         @input="setPassedDate(checkedOrders, $event)"
                         clearButton="false"
                         input-class="form-control form-control-sm"
                         lang="ru"
                         :first-day-of-week="1"
                         placeholder=""
                         style="width: auto;"
                         v-model="allPassedDate"
                         valueType="format">
            </date-picker>
          </div>
        </div>

      </div>
    </div>

    <v-dialog/>
    <modals-container/>
  </div>
</template>
<script>
import _ from 'lodash';
import moment from 'moment';
import VueBarcode from 'vue-barcode';
import DatePicker from 'vue2-datepicker';
import PartnerDelivery from '@/admin/modules/Delivery/_components/PartnerDelivery.vue';
import ReceptionHeadTr from '@/admin/modules/Delivery/_components/ReceptionHeadTr.vue';
import OrderTr from '@/admin/modules/Delivery/_components/OrderTr.vue';
import { get, post, put } from '@/admin/services/api/http-utils';
import AirDatepicker from '@/admin/components/AirDatepicker.vue';
import PartPaid from '@/admin/components/modals/PartPaid';

const queryString = require('query-string');

const url = `${process.env.VUE_APP_API_HOST}admin/debt`;
const type = 'partner';

export default {
  components: {
    DatePicker,
    PartnerDelivery,
    VueBarcode,
    ReceptionHeadTr,
    OrderTr,
    AirDatepicker,
  },
  props: {
    time: String,
    panelUserId: [String, Number],
    allowPrinting: Boolean,
    allowMarking: Boolean,
  },
  data() {
    return {
      orderList: [],
      orderListGroupByPoint: [],
      statuses: [],
      sferaNumber: '',
      courier: {},
      summaries: [],
      allIsDelivered: null,
      allIsPaid: null,
      allIsPassed: null,
      checkAll: false,
      checkedOrders: [],
      allPassedDate: null,
      allPaidDate: null,
      momentFormat: {
        // Date to String
        stringify: date => (date ? moment(date)
          .format('DD-MM-YYYY') : ''),
        // String to Date
        parse: value => (value ? moment(value, 'DD-MM-YYYY')
          .toDate() : null),
      },
      pointDebt: [],
    };
  },
  // async created() {
  //
  //   // this.fetchCourier();
  //   // this.calcAll();
  // },
  async mounted() {
    // this.fetchCourier();
    await this.fetchDebtByTourId();
    await this.fetchStatuses();
  },
  watch: {
    orderList() {
      if (this.orderList) {
        let arr = _.groupBy(this.orderList, 'Point.Id');
        arr = _.map(arr, x => _.orderBy(x, 'Point.Reception'));
        arr = _.orderBy(arr, x => _.head(x).Tour.Name);
        this.orderListGroupByPoint = arr;
      } else {
        this.orderListGroupByPoint = [];
      }
    },
    checkAll(newVal) {
      console.log(newVal);
      if (newVal) {
        this.checkedOrders = _.map(this.orderList, o => o.Order.Id);
      } else {
        this.checkedOrders = [];
      }
    },
    // orders() {
    //   this.calcAll();
    // },
  },
  computed: {
    allowPaymentTypes() {
      if (this.$route.query.allowPaymentTypeIds) {
        return _.filter(
          this.$root.paymentTypes, pt => pt.Id === this.$route.query.allowPaymentTypeIds,
        );
      }
      return this.$root.paymentTypes;
    },
    totalAmount() {
      const totalAmount = {};
      _.each(this.$root.paymentTypes, (val) => {
        totalAmount[val.Id] = _.sumBy(this.orderList, (o) => {
          if (o.Order.PaymentTypeId === val.Id) {
            return o.Order.Summary;
          }
        });
      });
      return totalAmount;
    },
    totalWithPassedDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PassedDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    totalWithPaidDate() {
      let totalAmount = 0;
      _.each(this.orderList, (o) => {
        if (o.Order.PaidDate) {
          totalAmount += o.Order.Summary;
        }
      });
      return totalAmount;
    },
    allowedStatuses() {
      return _.filter(this.statuses, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },
    allChecked() {
      return this.orderList.length === this.checkedOrders.length;
    },
    // customerOrders() {
    //   return _.groupBy(this.orders, order => order.order.CustomerId);
    // },
    courierBarCode() {
      return `cd_${this.$route.query.panelUserId}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    currentDate() {
      return moment()
        .format('DD-MM-YYYY, h:mm:ss');
    },
  },
  methods: {
    async setPassedDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-passed-date`, {
        orderItemIds,
        date,
      });
      this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    async deleteDelivery(DeliveryIds) {
      // if (!confirm('Подтвердите действие')) return;
      console.log(DeliveryIds);
      // return;
      await post(`${process.env.VUE_APP_API_HOST}admin/delivery/delete`, { DeliveryIds });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async setCurrentPassedDate(orderItemIds) {
      this.setPassedDate(orderItemIds, (new Date()).getTime() / 1000);
    },

    async setPaidDate(orderItemIds, date) {
      // if (!confirm('Подтвердите действие')) return;
      const { data } = await put(`${process.env.VUE_APP_API_HOST}admin/order/set-paid-date`, {
        orderItemIds,
        date,
      });
      this.$toasted.show('Выполнено', { type: 'success' });
      // await this.fetchDebtByTourId();
    },
    async setDeliveryPaidDate(orderItemIds) {
      const deliveryDate = _.head(this.orderList).Delivery.DeliveryDate;
      this.setPaidDate(orderItemIds, deliveryDate);
    },

    async setStatus(orderItemIds, statusCode) {
      // if (!confirm('Подтвердите действие')) return;
      await put(`${process.env.VUE_APP_API_HOST}admin/order/set-status`, {
        orderItemIds,
        statusCode,
      });
      this.$toasted.show('Выполнено', { type: 'success' });
      await this.fetchDebtByTourId();
    },
    async fetchStatuses() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/order-status`);
      this.statuses = data.data;// _.filter(data.data, o => _.includes(['in_dispatch', 'delivered'], o.Code));
    },

    partPaid(orderItemId) {
      const that = this;
      this.$modal.show(PartPaid, {
        orderItemId,
      }, {
        pivotY: 0.2,
        adaptive: true,
        height: 'auto',
      }, {
        'before-close': function () {
          that.fetchDebtByTourId();
        },
      });
    },
    // calcAll() {
    //   this.allIsDelivered = _.every(this.orders, item => item.delivery.IsDelivered);
    //   this.allIsPaid = _.every(this.orders, item => item.delivery.IsPaid);
    //   this.allIsPassed = _.every(this.orders, item => item.delivery.IsPassed);
    //
    //   console.log('this.orders', this.orders);
    //   this.summaryCreated();
    // },
    // checkBoxChanged(data) {
    //   console.log('checkBoxChanged', data);
    //   this.markDeliveries(data.PropName, data.DeliveryIDs, data.value);
    // },
    // summaryCreated() {
    //   this.summaries = [];
    //   if (!this.orders) return;
    //   console.log('this.orders', this.orders);
    //   console.log('this.$root.paymentTypes', Object.assign({}, this.$root.paymentTypes));
    //   let tourSummary = _.cloneDeep(this.$root.paymentTypes);
    //   tourSummary = _.mapKeys(tourSummary, item => item.Id);
    //   console.log('tourSummary', tourSummary);
    //   _.forEach(this.orders, (order) => {
    //     tourSummary[order.order.PaymentTypeId].Summary = tourSummary[order.order.PaymentTypeId].Summary || 0;
    //     tourSummary[order.order.PaymentTypeId].Summary += order.order.Summary;
    //     console.log('tourSummary', tourSummary[order.order.PaymentTypeId].Summary);
    //   });
    //   // this.$nextTick(() => {
    //   //   this.$emit('summary-created', Object.assign({}, tourSummary));
    //   // });
    //   this.summaries = tourSummary;
    //
    //   // console.log('this.orders', this.orders)
    //   // console.log('summaryCreated', Object.assign({}, data))
    //   // _.each(data, (v) => {
    //   //   const sumKey = _.findKey(this.summaries, { Id: v.Id });
    //   //   if (sumKey) {
    //   //     this.summaries[sumKey].Summary += Number(v.Summary);
    //   //   } else {
    //   //     this.summaries.push(v);
    //   //   }
    //   // });
    // },
    async fetchDebtByTourId() {
      const query = queryString.stringify({ allowedPaymentTypeId: this.$route.query.allowPaymentTypeIds });
      const { data } = await get(`${url}/tour-stats/${this.$route.params.tourId}?${query}`);
      this.orderList = data;
      this.fetchPointDebt();
    },
    async fetchPointDebt() {
      const pointIds = _.map(this.orderList, o => o.Point.Id);
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/delivery/point-debt/${pointIds.join(',')}`);
      this.pointDebt = data;
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    async fetchCourier() {
      const { data } = await get(`${url}/couriers/${this.$route.query.panelUserId}`);
      this.courier = data;
    },
    checkByPointId(event, PointId) {
      const value = event.target.checked;
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      // console.log('orderIds', orderIds);
      let merged = [];
      if (value) {
        merged.push(...this.checkedOrders);
        merged.push(...orderIds);
        merged = _.uniq(merged);
        this.checkedOrders = merged;
      } else {
        this.checkedOrders = _.filter(this.checkedOrders, id => !_.includes(orderIds, id));
      }

      // console.log(event.target.checked, PointId);
    },
    fullFilledPoint(PointId) {
      const orders = _.filter(this.orderList, o => o.Point.Id === PointId);
      const orderIds = _.map(orders, o => o.Order.Id);
      return !_.difference(orderIds, this.checkedOrders).length;
    },
    getStatusNameById(statusId) {
      // console.log(this.statuses, statusId)
      const status = _.find(this.statuses, o => o.Id === statusId);
      // console.log(status)
      return status ? status.Name : '';
      // return status.Name;
    },
    pointBarCode(Point) {
      return `pd_${Point.Id}_${moment(String(this.$route.query.time))
        .unix()}`;
    },
    // async addOrder() {
    //   try {
    //     const { data } = await get(`${url}/is-in-delivery/${this.sferaNumber}`);
    //     const appendOrder = async () => {
    //       await post(`${url}/append-order-to-delivery/${this.sferaNumber}`, {
    //         DeliveryDate: this.$route.query.time,
    //         PanelUserId: this.$route.query.panelUserId,
    //       });
    //       this.fetchDelivery();
    //       this.$modal.hide('dialog');
    //     };
    //     if (data) {
    //       this.$modal.show('dialog', {
    //         title: 'Предупреждение',
    //         text: `Заказ ${this.sferaNumber} уже есть в доставке на ${moment(String(data.DeliveryDate))
    //           .format('DD-MM-YYYY hh:mm')}`,
    //         buttons: [
    //           {
    //             title: 'Переназначить текущему пользователю', // Button title
    //             default: true, // Will be triggered by default if 'Enter' pressed.
    //             handler: appendOrder, // Button click handler
    //           },
    //           {
    //             title: 'Закрыть',
    //           },
    //         ],
    //       });
    //     } else {
    //       appendOrder();
    //     }
    //   } catch (error) {
    //     if (error.response && error.response.data) {
    //       this.$toasted.show(error.response.data, { type: 'error' });
    //     } else {
    //       this.$toasted.show('Неизвестная ошибка', { type: 'error' });
    //     }
    //   }
    // },
    // getDeliveryIDs() {
    //   return _.map(this.orders, item => item.delivery.Id);
    // },
    // allToDelivered() {
    //   this.markDeliveries('IsDelivered', this.getDeliveryIDs(), this.allIsDelivered);
    // },
    // allToPaid() {
    //   this.markDeliveries('IsPaid', this.getDeliveryIDs(), this.allIsPaid);
    // },
    // allToPassed() {
    //   this.markDeliveries('IsPassed', this.getDeliveryIDs(), this.allIsPassed);
    // },
    // markDeliveries(PropName, DeliveryIDs, value) {
    //   let titlePropName;
    //   switch (PropName) {
    //     case 'IsDelivered':
    //       titlePropName = 'Доставлены';
    //       break;
    //     case 'IsPaid':
    //       titlePropName = 'Оплачены';
    //       break;
    //     case 'IsPartPaid':
    //       titlePropName = 'Частично оплачены';
    //       break;
    //     case 'IsPassed':
    //       titlePropName = 'Сданы';
    //       break;
    //     default:
    //       titlePropName = null;
    //   }
    //   const mark = async () => {
    //     console.log(!value);
    //     await post(`${url}/mark-deliveries`, {
    //       PropName,
    //       DeliveryIDs,
    //       value: !value,
    //     });
    //     this.fetchDelivery();
    //     this.$modal.hide('dialog');
    //   };
    //   this.$modal.show('dialog', {
    //     title: 'Предупреждение',
    //     text: `Пометить доставки ${titlePropName ? `"${titlePropName}"` : ''}?`,
    //     buttons: [
    //       {
    //         title: 'Да', // Button title
    //         default: true, // Will be triggered by default if 'Enter' pressed.
    //         handler: mark,
    //       },
    //       {
    //         title: 'Отмена',
    //       },
    //     ],
    //   });
    // },
    // async commitPartAmount(data) {
    //   const { DeliveryId, PartAmount } = data;
    //   await put(url, { Id: DeliveryId, PartAmount });
    //   this.fetchDelivery();
    // },
  },
};
</script>
<style lang="scss">
.table-cell-align-middle {
  tr {
    td {
      vertical-align: middle;
    }
  }
}
</style>
